export const parseDate = (dateInput) => {
    if (!dateInput) return null;
    const dateStr = String(dateInput);
    let date;
    if (dateStr.match(/^\d{1,2}\/\d{1,2}\/\d{4}$/)) {
        const [day, month, year] = dateStr.split('/');
        date = new Date(`${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}T00:00:00`);
        if (!isNaN(date.getTime())) return date;
    }
    date = new Date(dateStr);
    if (!isNaN(date.getTime())) return date;
    return null;
}

export const renderDate = (dateInput, options) => {
    const date = parseDate(dateInput);
    if (!date) {
        return "รูปแบบไม่ถูกต้อง";
    }
    return date.toLocaleDateString('th-TH', options);
};
